module.exports = __webpack_public_path__ + "img/2paper.a38b943e.png";